// import { captureMessage, Severity } from '@sentry/browser';
// Import Config.
import { CONFIG_ENVIRONMENT } from '../../config';

/* eslint-disable @typescript-eslint/no-explicit-any */

export interface LogAppender {
  debug?: (...args: any[]) => void;
  info?: (...args: any[]) => void;
  warn?: (...args: any[]) => void;
  error?: (...args: any[]) => void;
  errorWithScope?: (contextName: string, contextValue: {[index: string]: any}, ...args: any[]) => void;
}

export enum LogLevels {
  verbose,
  info,
  warnings,
  errors
}

const consoleAppender: LogAppender = {
  debug: (...args) => {
    window.console.debug(...args);
  },
  info: (...args) => {
    window.console.info(...args);
  },
  warn: (...args) => {
    window.console.warn(...args);
  },
  error: (...args) => {
    window.console.error(...args);
  },
  errorWithScope: (...args) => {
    window.console.error(...args);
  }
};

const appenders: LogAppender[] = [consoleAppender];

export function registerAppender(appender: LogAppender): void {
  appenders.push(appender);
}

let logLevel: LogLevels;

// The value of CONFIG_ENVIRONMENT is replaced at build time which confuses tsc so we have to ts-ignore it
switch(CONFIG_ENVIRONMENT) {
  /* istanbul ignore next case */
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  case 'PRODUCTION':
    logLevel = LogLevels.errors;
    break;
  default:
    logLevel = LogLevels.verbose;
}

export function debug(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.verbose) {
    appenders
      .filter((appender) => typeof appender.debug === 'function')
      .forEach((appender) => {
        appender.debug(...args);
      });
  }
}

export function info(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.info) {
    appenders
      .filter((appender) => typeof appender.info === 'function')
      .forEach((appender) => {
        appender.info(...args);
      });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warn(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.warnings) {
    appenders
      .filter((appender) => typeof appender.warn === 'function')
      .forEach((appender) => {
        appender.warn(...args);
      });
  }
}

export function error(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.errors) {
    appenders
      .filter((appender) => typeof appender.error === 'function')
      .forEach((appender) => {
        appender.error(...args);
      });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorWithScope(contextName: string, contextValue: {[index: string]: any}, ...args: any[]): void {
  if (logLevel <= LogLevels.errors) {
    appenders
      .filter((appender) => typeof appender.errorWithScope === 'function')
      .forEach((appender) => {
        appender.errorWithScope(contextName, contextValue, ...args);
      });
  }
}
